export default {
  title: "Reporte de Usuarios"
  , filters: {
    users: "Usuario"
    , fecha: "Fecha Alta"
    , vendor: "Vendor"
    , rep: "REP"
    , enabled: "Status"
  }
  , tabla: {
    username: "Usuario"
    , nombre: "Nombre"
    , enabled: "Activo"
    , tipoUsuario: "Tipo de Usuario"
    , rep: "Código REP"
    , email: "Email"
    , celular: "Celular"
    , vendor: "Vendor"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/reportes/reporteusuarios.js